(function () {
  'use strict';

  angular.module('app').component('tourContentList', tourContentList());

  function tourContentList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onTourContentShowed: '&',
        websiteId: '<',
        defaultLanguage: '<',
      },
      controller: TourContentListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tour-contents/tour-content-list/tour-content-list.component.html',
    };
  }

  TourContentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'TourContentService',

    // Angular downgraded service
    'locationService',
  ];

  function TourContentListComponent(
    config,
    UtilService,
    AbilityService,
    TourContentService,

    // Angular downgraded service
    locationService
  ) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_tour_accountadmin'),
      canUpdate: AbilityService.can('update_tour_accountadmin'),
      canDestroy: AbilityService.can('destroy_tour_accountadmin'),
    };

    vm.featuredOptions = config.BOOLEAN_OPTIONS;
    vm.publishedOptions = config.BOOLEAN_OPTIONS;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = TourContentService.getFilterCriteria();

    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    // vm.onUpdateItems       = onUpdateItems;
    vm.changeItemFeatured = changeItemFeatured;
    vm.changeItemPublished = changeItemPublished;

    vm.searchLocations = (search) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      locationService.getLocations(params).subscribe((response) => {
        vm.locations = response;
      });
    };

    vm.clearLocations = () => {
      vm.locations = [];

      vm.UtilService.filterResult();
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      TourContentService.getToursContents(vm.websiteId, vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.locations = [];

      vm.filterCriteria = TourContentService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onTourContentShowed({ item: item });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      TourContentService.deleteTourContent(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      TourContentService.changeTourContentStatus(item);
    }

    /*function onUpdateItems(action) {
            let successCallback = function(){
                vm.showActions = false;
                vm.selectedAll = false;

                if (action === 'destroy'){
                    fetchResult();
                }
            };

            TourContentService.updateToursContents(action, vm.items, successCallback);
        }*/

    function changeItemFeatured(item) {
      TourContentService.changeTourContentFeatured(item);
    }

    function changeItemPublished(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      TourContentService.changeTourContentPublished(item);
    }
  }
})();
